import React from 'react';

interface Props {
  title?: string;
  description?: string;
}

export default function ComingSoonPage({
  title = 'Coming Soon',
  description = 'This feature is under development.',
}: Props) {
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--text-muted)"
          strokeWidth="1.5"
          style={{ marginBottom: 8 }}
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
        <h2 style={titleStyle}>{title}</h2>
        <p style={descStyle}>{description}</p>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  background: 'var(--bg-primary)',
  color: 'var(--text-primary)',
};

const cardStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 4,
  padding: '40px 48px',
  background: 'var(--bg-hover)',
  border: '1px solid var(--border-subtle)',
  borderRadius: 16,
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontSize: 20,
  fontWeight: 700,
  color: 'var(--text-secondary)',
};

const descStyle: React.CSSProperties = {
  margin: 0,
  fontSize: 14,
  color: 'var(--text-muted)',
  textAlign: 'center',
  maxWidth: 300,
};
